export default "__VITE_ASSET__CFvqzYoA__"